import { render, staticRenderFns } from "./viewPurchase.vue?vue&type=template&id=04faa00a&scoped=true&"
import script from "./viewPurchase.vue?vue&type=script&lang=js&"
export * from "./viewPurchase.vue?vue&type=script&lang=js&"
import style0 from "./viewPurchase.vue?vue&type=style&index=0&id=04faa00a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04faa00a",
  null
  
)

export default component.exports